import SubmissionsTab from './SubmissionsTab'

export default SubmissionsTab
